import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid"
import Link from "@mui/material/Link";
import { IconButton , Stack, Typography, useMediaQuery } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import PageviewIcon from '@mui/icons-material/Pageview';


export const YtdReportColumns: GridColDef[] = [
    { 
        field: 'cpfId', 
        headerName: 'CPF ID', 
        headerAlign: 'center', 
        align: 'center',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.value}`} target="_blank" underline="hover">{params.value}</Link>
        ),
    },
    { 
        field: 'filerName', 
        headerName: 'Name', 
        headerAlign: 'left', 
        align: 'left',
        width: 200,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <span>{params.value}</span>
        ),
    },
    { 
        field: 'filerNameWithId', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        minWidth: 150,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Link href={`/filers?q=${params.row.cpfId}`} target="_blank" underline="none">{params.row.cpfId}</Link>
                <span>&nbsp;{params.row.filerName}</span>
            </>  
        ),
    },
    { 
        field: 'officeSought', 
        headerName: 'Office Sought', 
        headerAlign: 'left',
        display: 'flex',
        align: 'left',
        minWidth: 250,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <span>{params.value}</span>        
        ),
    },
    { 
        field: 'incumbent', 
        headerName: 'Incumbent', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
             params.row.districtCodeHeld>0 &&
             <CheckIcon color="success" />
        ),
    },
    { 
        field: 'receiptsYtdNumeric', 
        headerName: 'Receipts YTD', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.row.cpfId}&section=Reports`} target="_blank" underline="hover">{params.row.receiptsYtd}</Link>
        ),
    },
    { 
        field: 'expendituresYtdNumeric', 
        headerName: 'Expenditures YTD', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.row.cpfId}&section=Reports`} target="_blank" underline="hover">{params.row.expendituresYtd}</Link>
        ),
    },
    { 
        field: 'currentCashOnHandNumeric', 
        headerName: 'Cash On Hand', 
        headerAlign: 'center',
        align: 'right',
        width: 250,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Link href={`/reports/displayreport?id=${params.row.bankReportId}`} target="_blank" underline="hover">{params.row.currentCashOnHand}</Link>
                <Typography paddingLeft={0.2} component={"span"} variant="body2">(as of {params.row.bankReportEndDate})</Typography>
            </> 
        ),
    },
]

export const YtdReportNonCandidateColumns: GridColDef[] = [
    { 
        field: 'cpfId', 
        headerName: 'CPF ID', 
        headerAlign: 'center', 
        align: 'center',
        width: 80,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.value}`} target="_blank" underline="hover">{params.value}</Link>
        ),
    },
    { 
        field: 'filerName', 
        headerName: 'Name', 
        headerAlign: 'left', 
        align: 'left',
        display: 'flex',
        minWidth: 420,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <span>{params.value}</span>
        ),
    },
    { 
        field: 'filerNameWithId', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        minWidth: 150,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Link href={`/filers?q=${params.row.cpfId}`} target="_blank" underline="none">{params.row.cpfId}</Link>
                <span>&nbsp;{params.row.filerName}</span>
            </>  
        ),
    },
    { 
        field: 'receiptsYtdNumeric', 
        headerName: 'Receipts YTD', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 110,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.row.cpfId}&section=Reports`} target="_blank" underline="hover">{params.row.receiptsYtd}</Link>
        ),
    },
    { 
        field: 'expendituresYtdNumeric', 
        headerName: 'Expenditures YTD', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 110,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.row.cpfId}&section=Reports`} target="_blank" underline="hover">{params.row.expendituresYtd}</Link>
        ),
    },
    { 
        field: 'currentCashOnHandNumeric', 
        headerName: 'Cash On Hand', 
        headerAlign: 'center',
        align: 'right',
        width: 250,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
                <Link href={`/reports/displayreport?id=${params.row.bankReportId}`} target="_blank" underline="none">{params.row.currentCashOnHand}</Link>
                <Typography paddingLeft={0.2} component={"span"} variant="body2">(as of {params.row.bankReportEndDate?params.row.bankReportEndDate: `${params.row.reportYear}`})</Typography>
            </> 
        ),
    },
]

export const PeriodicReportColumns: GridColDef[] = [
    { 
        field: 'cpfId', 
        headerName: 'CPF ID', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        maxWidth: 80,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.value}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
    },
    { 
        field: 'filerName', 
        headerName: 'Filer', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        minWidth: 140,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        ),
    },
    { 
        field: 'filerNameWithId', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        minWidth: 150,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">
                <Link href={`/filers?q=${params.row.cpfId}`} target="_blank" underline="none">{params.row.cpfId}</Link>
                <span>&nbsp;{params.row.filerName}</span>
            </Typography>  
        ),
    },
    { 
        field: 'reportYear', 
        headerName: 'Year', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        maxWidth: 80,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        ),
    },
    { 
        field: 'reportTypeShortDescription', 
        headerName: 'Type', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        maxWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.id}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>        
        ),
    },
    { 
        field: 'reportYearAndType', 
        headerName: 'Type', 
        headerAlign: 'left', 
        align: 'left',
        minWidth: 90,
        display: 'flex',
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/filers?q=${params.row.id}`} target="_blank" underline="none">{params.row.reportYear} {params.row.reportTypeShortDescription}</Link>  
        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Period', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        minWidth: 140,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        ),
    },
    { 
        field: 'startBalanceNumeric', 
        headerName: 'Start Balance', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.startBalance}</Typography>
        ),
    },
    { 
        field: 'receiptTotalNumeric', 
        headerName: 'Receipts', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.receiptTotal}</Typography>
        ),
    },
    { 
        field: 'expenditureTotalNumeric', 
        headerName: 'Expenditures', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.expenditureTotal}</Typography>
        ),
    },
    { 
        field: 'endBalanceNumeric', 
        headerName: 'End Balance', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.endBalance}</Typography>
        ),
    },
    { 
        field: 'filed', 
        headerName: 'Filed', 
        headerAlign: 'left', 
        align: 'left',
        display: 'flex',
        minWidth: 140,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        ),
    },
]

export const PrincipalReportColumns: GridColDef[] = [
    { 
        field: 'reportTypeDescription', 
        headerName: 'Type', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 70,
        flex: 1,
        display: 'flex',
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value.replace("Report", "")}</Typography>          
        )
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Period', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
        width: 200,
    },
    { 
        field: 'endDate', 
        headerName: 'Report Type', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 160,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Stack className="is-clickable" onClick={() => {window.open(`/reports/displayreport?id=${params.row.reportId}`, "_blank")}}>
                <Typography variant="body2">{params.row.reportTypeDescription}</Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover" variant="body2">{params.row.reportingPeriod}</Typography>
            </Stack>  
        )
    },
    { 
        field: 'startBalance', 
        headerName: 'Start Balance', 
        headerAlign: 'right', 
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">
                {params.value? params.row.startBalance : '-'}
            </Typography>        
        )
    },
    { 
        field: 'creditTotal', 
        headerName: 'Receipts', 
        headerAlign: 'right', 
        align: 'right',
        display: 'flex',
        minWidth: 110,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
           <Typography variant="body2">
               {params.value}{params.row.receiptTotal}
            </Typography>        
        )
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Expenditures', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 110,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        ),
    },
    { 
        field: 'endBalance', 
        headerName: 'End Balance', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 110,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">
                {params.value? params.row.endBalance : '-'}
            </Typography>        
        )
    },
    { 
        field: 'savingsBalance', 
        headerName: 'Savings', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 110,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">
                {params.value? params.row.savingsBalance : '-'}
            </Typography>        
        )
    },
    { 
        field: 'cashOnHand', 
        headerName: 'Cash on Hand', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">
                {params.value? params.row.cashOnHand : '-'}
            </Typography>        
        )
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    }
]

export const DepositoryYearEndReportColumns: GridColDef[] = [
    { 
        field: 'reportTypeDescription',
        headerName: 'Type',  
        headerAlign: 'center', 
        align: 'center',
        width: 120,
        display: 'flex',
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.reportYear} Year End</Typography>
        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Period', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
        width: 200,
    },
    { 
        field: 'endDate', 
        headerName: 'Report Type', 
        headerAlign: 'left',
        align: 'left',
        display: 'flex',
        flex: 1,
        minWidth: 160,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Stack className="is-clickable" onClick={() => {window.open(`/reports/displayreport?id=${params.row.reportId}`, "_blank")}}>
                <Typography variant="body2">{params.row.reportYear} Year End</Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover" variant="body2">{params.row.reportingPeriod}</Typography>
            </Stack>  
        ),
    },
    { 
        field: 'endBalance', 
        headerName: 'Bank Reported EB', 
        headerAlign: 'right', 
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'inTransitAdjustment', 
        headerName: 'In-Transit', 
        headerAlign: 'right', 
        align: 'right',
        display: 'flex',
        minWidth: 80,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'savingsTotal', 
        headerName: 'Savings', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'totalCashOnHand', 
        headerName: 'Total COH', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'liabilityItemizedTotal', 
        headerName: 'Liabilities', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'inkindTotal', 
        headerName: 'Inkinds', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    }
]

export const DepositReportColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
        width: 120,
    },
    { 
        field: 'endDate', 
        headerName: 'Report Type', 
        headerAlign: 'left',
        align: 'left',
        display: 'flex',
        flex: 1,
        minWidth: 150,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Stack className="is-clickable" onClick={() => {window.open(`/reports/displayreport?id=${params.row.reportId}`, "_blank")}}>
                <Typography variant="body2">{params.row.reportTypeDescription}</Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover" variant="body2">{params.value}</Typography>
            </Stack>  
        ),
    },
    { 
        field: 'depositSequence', 
        headerName: 'Sequence', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'receiptItemizedTotal', 
        headerName: 'Itemized Receipts', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )

    },
    { 
        field: 'receiptUnitemizedTotal', 
        headerName: 'Unitemized Receipts', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'receiptAdjustedTotal', 
        headerName: 'Receipt Total', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'merchantProviderFeeTotal', 
        headerName: 'Fees', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'netDepositTotal', 
        headerName: 'Net Deposit', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    }
]

export const ReimbursementReportColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'endDate', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'reimbursee', 
        headerName: 'Reimbursee', 
        headerAlign: 'left',
        align: 'left',
        display: 'flex',
        flex: 1,
        minWidth: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
    },
    { 
        field: 'expenditureItemizedTotal', 
        headerName: 'Itemized Expenses', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )    

    },
    { 
        field: 'expenditureUnitemizedTotal', 
        headerName: 'Unitemized Expenses', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )

    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Total Reimbursement', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    }
]

export const CreditCardReportColumns: GridColDef[] = [
    { 
        field: 'accountName', 
        headerName: 'Account', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 70,
        flex: 0.5,
        display: 'flex',
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Period', 
        headerAlign: 'center', 
        align: 'center',
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
        width: 200,
    },
    { 
        field: 'endDate', 
        headerName: 'Period', 
        headerAlign: 'left',
        align: 'left',
        display: 'flex',
        flex: 1,
        minWidth: 160,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Stack className="is-clickable" onClick={() => {window.open(`/reports/displayreport?id=${params.row.reportId}`, "_blank")}}>
                <Typography variant="body2">{params.row.accountName}</Typography>
                <Typography component={Link} href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover" variant="body2">{params.row.reportingPeriod}</Typography>
            </Stack>  
        )
    },
    { 
        field: 'startBalance', 
        headerName: 'Start Balance', 
        headerAlign: 'right', 
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'totalCharges', 
        headerName: 'Total Charges', 
        headerAlign: 'right', 
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'paymentsMade', 
        headerName: 'Payments', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'endBalance', 
        headerName: 'End Balance', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    }
]

export const PayrollReportColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'endDate', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'vendorName', 
        headerName: 'Payroll Vendor', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
    },
    { 
        field: 'expenditureItemizedTotal', 
        headerName: 'Payroll Expenditure Amount', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )

    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    }
]

export const SubvendorReportColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )

    },
    { 
        field: 'endDate', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    },
    { 
        field: 'vendorName', 
        headerName: 'Payroll Vendor', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>
        ),
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Subvendor Expense Total', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )

    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 120,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>
        )
    }
]

export const BankExpenditureItemizationReportColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Expenditure Date', 
        headerAlign: 'center', 
        align: 'center',
        width: 150
    },
    { 
        field: 'endDate', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 120
    },
    { 
        field: 'vendorName', 
        headerName: 'Vendor', 
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.value}</Link>
        ),
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Bank Expenditure Amount', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1

    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 120,
        flex:1
    }
]

export const LateContributionReportColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        width: 150,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.value}</Link>
        ),
    },
    { 
        field: 'endDate', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 120,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.value}</Link>
        ),
    },
    { 
        field: 'receiptTotal', 
        headerName: 'Total Receipts', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1

    },
    { 
        field: 'inkindTotal', 
        headerName: 'Total Inkinds', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1

    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 120,
        flex:1
    }
]

export const DonationReportColumns: GridColDef[] = [
    { 
        field: 'reportTypeDescription', 
        headerName: 'Type', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 120,
        flex:1,
        sortable: false
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        width: 180,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.value}</Link>
        ),
    },
    { 
        field: 'endDate', 
        headerName: 'Date', 
        headerAlign: 'center',
        align: 'center',
        width: 120
    },
    { 
        field: 'receiptItemizedTotal', 
        headerName: 'Itemized Donations', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1

    },
    { 
        field: 'receiptUnitemizedTotal', 
        headerName: 'Unitemized Donations', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1

    },
    { 
        field: 'receiptTotal', 
        headerName: 'Total Donations	', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 120,
        flex:1

    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 120,
        flex:1
    }
]

export const OtherPeriodicReportColumns: GridColDef[] = [
    { 
        field: 'reportYear', 
        headerName: 'Year', 
        headerAlign: 'center',
        align: 'center',
        width: 60,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        ),
    },
    { 
        field: 'reportTypeDescription', 
        headerName: 'Type', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 140,
        flex:1,
        display: 'flex',
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value.replace("Report", "")}</Typography>                
        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Period', 
        headerAlign: 'center',
        align: 'center',
        minWidth: 160,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.value}</Link>        
        ),
    },
    { 
        field: 'endDate', 
        headerName: 'Period', 
        headerAlign: 'center', 
        align: 'center',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.row.reportingPeriod}</Link>
        ),
        width: 160,
    },
    { 
        field: 'startBalanceNumeric', 
        headerName: 'Start Balance', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 100,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.row.startBalance}</Typography>
        ),
    },
    { 
        field: 'receiptTotalNumeric', 
        headerName: 'Receipts', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 100,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.row.receiptTotal}</Typography>
        ),
    },
    { 
        field: 'expenditureTotalNumeric', 
        headerName: 'Expenditures', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 100,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.row.expenditureTotal}</Typography>
        ),
    },
    { 
        field: 'endBalanceNumeric', 
        headerName: 'End Balance', 
        headerAlign: 'right',
        align: 'right',
        minWidth: 100,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.row.endBalance}</Typography>
        ),
    },
    { 
        field: 'liabilityItemizedTotal', 
        headerName: 'Liabilities', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'inkindTotal', 
        headerName: 'Inkinds', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.value}</Typography>        
        )
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center', 
        align: 'center',
        width: 120,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>        
        ),
    },
]

export const IEPacReportFilerColumns: GridColDef[] = [
    { 
        field: 'reportingPeriod', 
        headerName: 'Reporting Period', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 200,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.value}</Link>        
        ),
    },
    { 
        field: 'endDate', 
        headerName: 'Period', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 100,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">{params.row.reportingPeriod}</Link>
        ),
    },
    { 
        field: 'candidateListing', 
        headerName: 'Candidate', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 600,
        flex:1,
        display: 'flex',
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>        
        ),
    },
    { 
        field: 'receiptTotal', 
        headerName: 'Receipts', 
        headerAlign: 'right',
        align: 'right',
        maxWidth: 150,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>        
        ),
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Expenditures', 
        headerAlign: 'right',
        align: 'right',
        maxWidth: 150,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>        
        ),
    },
    { 
        field: 'dateFiled', 
        headerName: 'Filed', 
        headerAlign: 'center', 
        align: 'right',
        maxWidth: 120,
        flex:1,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="subtitle2">{params.value}</Typography>        
        ),
    },
]

export const IEPacReportColumns: GridColDef[] = [
    { 
        field: 'reportId', 
        headerName: '', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 50,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <IconButton  href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" >
                <PageviewIcon />
            </IconButton >

        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 200,
        flex:1,
    },
    { 
        field: 'cpfId', 
        headerName: 'ID', 
        headerAlign: 'left', 
        align: 'left',
        maxWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={'/filers?q='+params.row.cpfId} target='_blank'>{params.row.cpfId}</Link>

        ),
    },
    { 
        field: 'committeeName', 
        headerName: 'Filer', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 300,
        flex:1,
    },
    { 
        field: 'candidateListing', 
        headerName: 'Candidate', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'expenditureTotalDisplay', 
        headerName: 'Exp. Total', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 100,
        flex:1,
    },
]

export const IepacYearEndReportColumns: GridColDef[] = [
    { 
        field: 'filerNameWithId', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        minWidth: 250,
        flex:2,
        display: 'flex',
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">
                <Link href={`/filers?q=${params.row.cpfId}`} target="_blank" underline="none">{params.row.cpfId}</Link>
                <span>&nbsp;{params.row.filerName}</span>
            </Typography>  
        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Period', 
        headerAlign: 'center',
        align: 'center',
        display: 'flex',
        minWidth: 140,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Link href={`/reports/displayreport?id=${params.row.reportId}`} target="_blank" underline="hover">
                <Typography variant="body2">{params.value}</Typography>
            </Link>         
        ),
    },
    { 
        field: 'startBalanceNumeric', 
        headerName: 'Start Balance', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.startBalance}</Typography>
        ),
    },
    { 
        field: 'receiptTotalNumeric', 
        headerName: 'Receipts', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.receiptTotal}</Typography>
        ),
    },
    { 
        field: 'expenditureTotalNumeric', 
        headerName: 'Expenditures', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.expenditureTotal}</Typography>
        ),
    },
    { 
        field: 'endBalanceNumeric', 
        headerName: 'End Balance', 
        headerAlign: 'right',
        align: 'right',
        display: 'flex',
        minWidth: 100,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <Typography variant="body2">{params.row.endBalance}</Typography>
        ),
    }
]

export const IEReportColumns: GridColDef[] = [
    { 
        field: 'reportId', 
        headerName: '', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 50,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <IconButton  href={`/reports/displayreport?id=${params.row.id}&isIE=1`} target="_blank" >
                <PageviewIcon />
            </IconButton >

        ),
    },
    { 
        field: 'date', 
        headerName: 'Report Date', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 200,
        flex:1,
    },
    { 
        field: 'filingEntity', 
        headerName: 'Filer', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 300,
        flex:1,
    },
    { 
        field: 'candidateListing', 
        headerName: 'Candidate', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Exp. Total', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 100,
        flex:1,
    },
]

export const IEReportItemsColumns: GridColDef[] = [
    { 
        field: 'date', 
        headerName: 'Date', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 100,
        flex:1,
    },
    { 
        field: 'vendor', 
        headerName: 'Name', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 250,
        flex:1,
        renderCell: (params: GridRenderCellParams<any>) => (
            <>
            <Typography component={'p'}>{params.row.vendor}</Typography>
            {params.row.streetAddress && <Typography component={'p'}>{params.row.streetAddress + ' ' + params.row.city + ' ' + params.row.state + ' ' + params.row.zipCode}</Typography>}
            </>
        ),
    },
    { 
        field: 'filingEntity', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        maxWidth: 250,
        flex:1,
    },
    { 
        field: 'candidateListing', 
        headerName: 'Candidate', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'amount', 
        headerName: 'Amount', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 100,
        flex:1,
    },
]

export const BallotQuestionSpendingReportColumns: GridColDef[] = [
    { 
        field: 'reportId', 
        headerName: '', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 50,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <IconButton  href={`/reports/displayreport?id=${params.row.reportId}&isIE=1`} target="_blank" >
                <PageviewIcon />
            </IconButton >

        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Reporting Period', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 200,
        flex:1,
    },
    { 
        field: 'filingEntity', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        maxWidth: 250,
        flex:1,
    },
    { 
        field: 'stateBqDescription', 
        headerName: 'Ballot Question', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'position', 
        headerName: 'Position', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Amount', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 100,
        flex:1,
    },
]

export const ElectioneeringCommunicationReportColumns: GridColDef[] = [
    { 
        field: 'reportId', 
        headerName: '', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 50,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <IconButton  href={`/reports/displayreport?id=${params.row.reportId}&isIE=1`} target="_blank" >
                <PageviewIcon />
            </IconButton >

        ),
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Report Date', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 200,
        flex:1,
    },
    { 
        field: 'filingEntity', 
        headerName: 'Filer', 
        headerAlign: 'left', 
        align: 'left',
        maxWidth: 250,
        flex:1,
    },
    { 
        field: 'candidateListing', 
        headerName: 'Candidate', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Expenditure Total', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 200,
        flex:1,
    },
]

export const PoliticalSpendingReportColumns: GridColDef[] = [
    { 
        field: 'reportId', 
        headerName: '', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 50,
        flex:1,
        sortable: false,
        renderCell: (params: GridRenderCellParams<any>) => (
            <IconButton  href={`/reports/displayreport?id=${params.row.reportId}&isIE=1`} target="_blank" >
                <PageviewIcon />
            </IconButton >

        ),
    },
    { 
        field: 'date', 
        headerName: 'Date Filed', 
        headerAlign: 'center', 
        align: 'center',
        maxWidth: 200,
        flex:1,
    },
    { 
        field: 'filingEntity', 
        headerName: 'Organization', 
        headerAlign: 'left', 
        align: 'left',
        maxWidth: 250,
        flex:1,
    },
    { 
        field: 'reportingPeriod', 
        headerName: 'Reporting Period', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 400,
        flex:1,
    },
    { 
        field: 'expenditureTotal', 
        headerName: 'Expenditure Total', 
        headerAlign: 'left',
        align: 'left',
        maxWidth: 200,
        flex:1,
    },
]

